<template>
  <div class="footer-right" :class="{ visible: isVisible }">
    <div class="footer-title">
      SK’s Journey with <br />
      Challenge, Passion and Integrity
    </div>

    <FamilyDropdown />
  </div>
</template>

<script>
import FamilyDropdown from './FamilyDropdown.vue';

export default {
  name: 'FooterRight',
  components: {
    FamilyDropdown
  },
  data() {
    return {
      isVisible: false,
      observer: null
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting;
      },
      {
        threshold: 0.2
      }
    );
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
.footer-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  opacity: 0;
  transform: translateX(30px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.footer-right.visible {
  opacity: 1;
  transform: translateX(0);
}

.footer-title {
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 600;
  line-height: 1.4;
  text-align: right;
  background: linear-gradient(90deg, #ef1a42 0%, #ee7501 74%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  margin-bottom: 24px;
}

@media (max-width: 1200px) {
  .footer-title {
    display: none;
  }
}

@media (max-width: 768px) {
  .footer-title {
    display: block;
    text-align: left;
  }

  .footer-right {
    align-items: flex-start;
  }
}
</style>
